import React from "react";
import {Container, Row, Col, Card, CardBody, CardTitle, Table, Nav, NavItem, NavLink} from 'reactstrap';
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";

const VendorDashboard = () => {

const stats = [
  { label: 'Total Submissions', value: 90 },
  { label: 'Candidates in Review', value: 30 },
  { label: 'Interviews Scheduled', value: 15 },
  { label: 'Offers Released', value: 29 },
  { label: 'Rejected Candidates', value: 15 },
  { label: 'Upcoming Interviews', value: 15 },
  { label: 'Success Ration', value: '76%' },
];

const techStack = [
  { tech: 'Frontend', submitted: 10, selected: 3 },
  { tech: 'React', submitted: 5, selected: 2 },
  { tech: 'UI UX', submitted: 5, selected: 1 },
  { tech: 'Java', submitted: 15, selected: 7 },
  { tech: 'Devops', submitted: 8, selected: 3 },
];

  return (
<div className="py-5 px-5">
    <Row className="mt-3">
    <Col>
      <PageSubHeader
        heading={"Dashboard"}
        routePath={"Home"}
        pageName={"Dashboard"}
      />
      <p className="text-muted pt-2">
        Track Your Candidates. Monitor Every Move. Deliver Results
      </p>
    </Col>
   </Row> 

  <Container fluid className="py-3">
     <Row>
      {stats.map((item, index)=>(
         <Col md="3" className="mb-3">
           <Card className="border shadow p-4 rounded-3"
            style={{ height: '120px', width: '290px', fontSize: '0.85rem' }}>
            <CardBody className="d-flex flex-column justify-content-center">
            <CardTitle tag="h6" className="text-muted">{item.label}</CardTitle>
            <h5>{item.value}</h5>
        </CardBody>
        </Card>
     </Col>
      ))}
     </Row>

    <Row className="mt-3">
       <Col>
           <h2 style={{ color: "#222222" }}>Technology Stack</h2>
       </Col>                
     </Row>
     <Row>
          <Card>
          <CardBody>
          <div className="table-responsive">
           <Table className="table mb-0" style={{border: "0.4px solid #D4D4D4"}}>
            <thead>
            <tr className='text-[#222222]'>        
              <th className="ps-4">Tech Stack</th>
              <th className="text-center">Total Profiles Submitted</th>
              <th className="text-center">Selected</th>
                                          
            </tr>
            </thead>
            <tbody>
            {techStack.map((item, index) => (
           <tr key={index}>
            <td className="ps-4">{item.tech}</td>
            <td className="text-center">{item.submitted}</td>
            <td className="text-center">{item.selected}</td>
           </tr>
            ))}
          </tbody>
        </Table>
      </div>
      </CardBody>
      </Card>
     </Row>
</Container>
</div>

);
};

export default VendorDashboard;
